export const ButtonIconPosition = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};
